import { AddressColorResponseItem, AddressColorResponseList } from '@/types/service-response'

export class AddressColor {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly name: string,
    readonly color: string,
    readonly type : string

  ) {}

  static createFromResponse (responseData: AddressColorResponseList): Array<AddressColor> {
    let result: Array<AddressColor> = []
    if (responseData) {
      result = responseData.map((data: AddressColorResponseItem ) => {
        return new AddressColor(
          data.ID,
          data.Code,
          data.Bezeichnung,
          data.Farbe,
          data.Type
        )
      })
    }
    return result
  }
}
